export const usePrivate = `공고일자: 2026년 10월 1일 · 시행일자: 2026년 10월 1일
기역기역 주식회사(이하 "회사")는 「개인정보 보호법」 제30조에 따라 팬버드(Fanbird) 서비스를 이용하는 회원(구매자)의 개인정보를 어떻게 처리하는지 알리고, 관련 고충을 신속하게 처리하기 위하여 다음과 같이 개인정보 처리방침을 수립·공개합니다.
제1조 (처리 목적, 항목, 근거 및 보유기간)
회사는 다음 목적을 위해 필요한 최소한의 개인정보를 처리하며, 목적이 바뀌는 경우 별도 동의를 받는 등 필요한 조치를 합니다.
처리 목적
처리 항목
처리 근거
보유기간
회원가입 및 관리(카카오 싱크)
[필수] 카카오 회원번호, 닉네임, 프로필 사진, 이메일, 휴대전화번호
계약 이행(법 제15조 제1항 제4호)
탈퇴 시까지
상품 주문, 배송, 교환·반품·환불
[필수] 주문자·수령인 이름, 휴대전화번호, 배송지 주소, 주문내역 / [PG결제] 결제수단, 승인정보 / [가상계좌] 입금은행, 가상계좌번호, 입금자명, 환불계좌(환불 시) / [무통장] 입금자명, 환불계좌(환불 시) / [선택] 공동현관 출입번호, 배송 요청사항
계약 이행(법 제15조 제1항 제4호)
거래 완료 후 법정 보존기간(제2조)
고객상담 및 분쟁 처리
상담 내용, 연락처, 주문정보
계약 이행(법 제15조 제1항 제4호)
처리 완료 후 3년
셀러 팔로우 및 라이브 시작·이벤트 알림(광고성 정보)
[선택] 휴대전화번호, 팔로우 내역, 수신동의 일시·채널, 야간 수신동의 여부
정보주체 동의(법 제15조 제1항 제1호)
동의 철회 또는 탈퇴 시까지
부정이용 방지
탈퇴 회원의 카카오 회원번호, 휴대전화번호, 이용제한 이력
정당한 이익(법 제15조 제1항 제6호)
탈퇴 후 1년
서비스 안정성 확보, 통계 분석, 로그인 세션 유지
[자동수집] IP 주소, 쿠키, 접속 로그, 접속 일시, 기기정보(OS, 모델명), 라이브 시청·팔로우·장바구니 기록
정당한 이익(법 제15조 제1항 제6호)
수집일부터 1년(웹사이트 방문기록은 최소 3개월 보관)
제2조 (법령에 따른 보존)
회사는 관련 법령에 따라 다음 정보를 정해진 기간 동안 별도 분리하여 보관합니다.
보존 항목
기간
근거 법령
계약 또는 청약철회 등에 관한 기록
5년
전자상거래법
대금결제 및 재화 등의 공급에 관한 기록
5년
전자상거래법
소비자 불만 또는 분쟁처리에 관한 기록
3년
전자상거래법
표시·광고에 관한 기록
6개월
전자상거래법
전자금융거래에 관한 기록(PG결제)
5년
전자금융거래법
웹사이트 방문 기록
3개월
통신비밀보호법
제3조 (개인정보의 제3자 제공)
① 회사는 회원의 개인정보를 제1조의 목적 범위에서만 처리하며, 회원의 동의 또는 법률의 특별한 규정이 있는 경우에만 제3자에게 제공합니다.
② 회사는 통신판매중개자로서 거래 이행을 위해 회원이 주문할 때 별도 동의를 받아 다음과 같이 셀러에게 제공합니다.
제공받는 자
제공 목적
제공 항목
보유기간
회원이 주문한 해당 셀러
상품 배송, 교환·반품·환불, 고객상담
주문자·수령인 이름, 휴대전화번호, 배송지 주소, 주문내역, 배송 요청사항, (무통장 환불 시) 환불계좌
거래 완료 후 법정 보존기간 종료 시까지
③ 셀러는 제공받은 정보를 위 목적 외로 이용할 수 없으며, 개인 연락, 외부 채널(밴드, 카카오채널, SNS 등) 홍보, 별도 마케팅에 사용할 수 없습니다. 라이브 시작 알림 등은 회사 시스템을 통해서만 발송되며 셀러에게 회원의 연락처를 제공하지 않습니다.
④ 팔로우 시 셀러에게는 회원의 닉네임과 팔로우 여부만 표시됩니다.
⑤ 회사는 수사기관의 영장, 국세청 등 관계기관의 법령에 따른 요청이 있는 경우 동의 없이 필요한 범위에서 개인정보를 제공할 수 있습니다.
제4조 (개인정보 처리업무의 위탁)
① 회사는 서비스 제공을 위해 다음과 같이 개인정보 처리업무를 위탁하고 있습니다.
수탁자
위탁 업무
주식회사 헥토파이낸셜
전자결제대행(PG), 결제대금 정산
주식회사 알리고
카카오 알림톡·문자 발송 대행(주문·결제·배송 안내, 라이브 시작 알림)
Amazon Web Services, Inc.
클라우드 서버 운영 및 데이터 보관
② 위탁 기간은 회원 탈퇴 또는 위탁계약 종료 시까지입니다.
③ 회사는 위탁계약 시 위탁 목적 외 처리 금지, 안전성 확보조치, 재위탁 제한, 관리·감독, 손해배상 등을 문서로 정하고 수탁자를 감독합니다. 수탁자나 업무가 바뀌면 이 처리방침을 통해 공개합니다.
제5조 (개인정보의 국외 이전)
회사는 AWS 아시아 태평양(서울) 리전에 개인정보를 저장하며, 현재 개인정보를 국외로 이전하지 않습니다.
제6조 (개인정보의 파기)
① 회사는 보유기간이 지나거나 처리 목적을 달성한 개인정보를 지체 없이 파기합니다. 법령에 따라 보존하는 정보는 별도 데이터베이스로 옮겨 분리 보관하고, 보존기간이 끝나면 파기합니다.
② 전자적 파일은 복구할 수 없는 방법으로 영구 삭제하며, 종이 문서는 분쇄하거나 소각합니다.
③ 카카오 계정 연결 해제나 앱 삭제만으로는 회원정보가 삭제되지 않으므로, 삭제를 원하는 경우 회원 탈퇴를 하여야 합니다.
제7조 (정보주체의 권리와 행사 방법)
① 회원은 언제든지 개인정보 열람, 정정·삭제, 처리정지, 동의 철회를 요구할 수 있으며, 마이페이지 또는 고객센터, 이메일, 서면으로 행사할 수 있습니다. 회사는 지체 없이(10일 이내) 조치하고 결과를 알립니다.
② 법령에서 보존을 요구하는 정보는 삭제를 요구할 수 없으며, 처리정지 요구는 법령에 따라 거절될 수 있습니다. 이 경우 회사는 그 사유를 알립니다.
③ 법정대리인이나 위임받은 자를 통해서도 권리를 행사할 수 있으며, 이 경우 「개인정보 처리 방법에 관한 고시」에 따른 위임장을 제출하여야 합니다.
④ 회사는 회원에게 법적 효력이나 중대한 영향을 미치는 완전히 자동화된 결정을 하지 않습니다.
제8조 (만 14세 미만 아동의 개인정보)
회사는 만 14세 미만 아동의 회원가입을 받지 않으며, 그 개인정보를 수집하지 않습니다. 가입 후 만 14세 미만으로 확인된 경우 해당 정보를 지체 없이 파기합니다.
제9조 (안전성 확보조치)
회사는 개인정보의 안전성 확보를 위해 다음 조치를 합니다.
1. 관리적 조치: 내부관리계획 수립·시행, 개인정보취급자 최소화와 정기 교육, 수탁자 점검
2. 기술적 조치: 접근권한 관리, 접근통제, 전송구간 암호화(TLS), 비밀번호·계좌번호 등 중요정보 암호화, 접속기록 보관·점검, 보안프로그램 설치
3. 셀러 접근 통제: 셀러의 주문정보 열람·다운로드는 주문일부터 3개월 이내로 제한하고, 다운로드 기록을 남기며, 기간이 지난 정보는 마스킹 처리
4. 물리적 조치: 클라우드 사업자의 보안 인증을 받은 시설 이용, 문서 보관 장소 접근 통제
제10조 (자동수집장치의 설치·운영 및 거부)
① 회사는 로그인 유지, 이용 통계 분석을 위해 쿠키와 유사 기술을 사용합니다.
② 회원은 브라우저 설정(예: 크롬 > 설정 > 개인정보 보호 및 보안 > 서드 파티 쿠키)에서 쿠키 저장을 거부하거나 삭제할 수 있습니다. 다만 거부 시 로그인 유지 등 일부 서비스 이용이 어려울 수 있습니다.
③ 회사는 라이브 시청, 팔로우, 장바구니 기록 등 행태정보를 서비스 내 추천과 통계에 이용합니다. 회사는 승인하지 않은 외부 태그·스크립트의 삽입을 통제하며, 회원은 제2항의 쿠키 차단으로 태그에 의한 수집을 거부할 수 있습니다.
제11조 (개인정보 보호책임자)
회사는 개인정보 처리에 관한 업무를 총괄하고 관련 불만 처리와 피해 구제를 위해 다음과 같이 개인정보 보호책임자를 지정합니다.
• 성명: 이헌영 / 직위: 대표이사
• 전화: 0507-1336-7115 / 이메일: linkcampus01@gmail.com
제12조 (권익침해 구제방법)
회원은 개인정보 침해에 대한 신고나 상담이 필요한 경우 다음 기관에 문의할 수 있습니다.
• 개인정보분쟁조정위원회: 1833-6972 (www.kopico.go.kr)
• 개인정보침해신고센터: 국번 없이 118 (privacy.kisa.or.kr)
• 대검찰청: 국번 없이 1301 (www.spo.go.kr)
• 경찰청: 국번 없이 182 (ecrm.police.go.kr)
제13조 (처리방침의 변경)
이 처리방침을 변경하는 경우 시행 7일 전부터 공지사항으로 알리며, 수집 항목 추가나 제3자 제공 등 회원 권리에 중요한 변경은 30일 전부터 알립니다. 이전 처리방침은 플랫폼에서 계속 열람할 수 있도록 합니다.`;
